module.exports = __webpack_public_path__ + "static/media/ic-specialist.35bfe093.png";